import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "align", "columns", "columnsSizes", "isRtl"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import styled, { css } from 'styled-components';
import Box from '../layout/Box';
import { jsx as _jsx } from "react/jsx-runtime";

var normalizeAlign = function normalizeAlign(align) {
  if (align === 'top') {
    return 'flex-start';
  }

  if (align === 'bottom') {
    return 'flex-end';
  }

  return align;
};

export var GridColumn = styled(Box).withConfig({
  displayName: "Grid__GridColumn",
  componentId: "sc-88sllu-0"
})(["", ""], function (_ref) {
  var theme = _ref.theme,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 1 : _ref$size,
      _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? 1 : _ref$columns;
  var columnWidth;

  if (columns) {
    columnWidth = (100 / columns * size).toFixed(2);
  }

  return css(["", " ", ""], theme.mq.small({
    maxWidth: '100%',
    flex: '0 0 100%'
  }), columnWidth && css(["max-width:", "%;flex:0 0 ", "%;"], columnWidth, columnWidth));
});

var GridBase = function GridBase(_ref2) {
  var children = _ref2.children,
      _ref2$align = _ref2.align,
      align = _ref2$align === void 0 ? 'center' : _ref2$align,
      columns = _ref2.columns,
      _ref2$columnsSizes = _ref2.columnsSizes,
      columnsSizes = _ref2$columnsSizes === void 0 ? [] : _ref2$columnsSizes,
      _isRtl = _ref2.isRtl,
      restProps = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
    $mx: [null, -10, -10, -10],
    $styles: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: normalizeAlign(align)
    }
  }, restProps), {}, {
    children: React.Children.map(children, function (child, index) {
      return /*#__PURE__*/_jsx(GridColumn, {
        columns: columns,
        size: columnsSizes[index] || 1,
        $px: [null, 10, 10, 10],
        $styles: {
          maxWidth: ['100%', null, null, null],
          flex: ['0 0 100%', null, null, null]
        },
        children: child
      });
    })
  }));
};

var Grid = styled(GridBase).withConfig({
  displayName: "Grid",
  componentId: "sc-88sllu-1"
})(["", ""], function (_ref3) {
  var isRtl = _ref3.isRtl;
  return isRtl && css(["", ":first-child{order:2;padding-left:8.33%;position:relative;", "}", ":last-child{", "}"], GridColumn, function (_ref4) {
    var theme = _ref4.theme;
    return theme.normalizeStyles({
      left: [null, 10, 10, 10],
      order: [1, 2, 2, 2],
      paddingLeft: [0, '8.33%', '8.33%', '8.33%']
    });
  }, GridColumn, function (_ref5) {
    var theme = _ref5.theme;
    return theme.normalizeStyles({
      order: [2, 1, 1, 1]
    });
  });
});
export default Grid;